import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import { Pagination, Autoplay } from "swiper/bundle";
import gamerI1 from "../assets/imgs/OurGamer1.png";
import gamerI2 from "../assets/imgs/OurGamer2.png";
import {
  Col,
  Row,
  CardTitle,
  CardSubtitle,
  CardText,
  Container,
} from "reactstrap";
import Flickity from "react-flickity-component";
import { connect } from "react-redux";
import { getFeedbacks } from "../redux/actions/feedbackActions";
import moment from "moment";
// const swiper = new Swiper('.swiper-container', {
//     // Default parameters
//     slidesPerView: 1,
//     spaceBetween: 10,
// });
//     // Responsive breakpoints
//     breakpoints: {
//         // when window width is >= 320px
//         320: {
//             slidesPerView: 2,
//             spaceBetween: 20
//         },
//         // when window width is >= 480px
//         480: {
//             slidesPerView: 3,
//             spaceBetween: 30
//         },
//         // when window width is >= 640px
//         640: {
//             slidesPerView: 4,
//             spaceBetween: 40
//         }
//     }
// })

class FeedbackCarousel extends Component {
  componentDidMount() {
    this.props.getFeedbacks();
  }
  render() {
    var { feedbacks } = this.props;
    return (
      <>
        {/* <Swiper centeredSlides={true}
                    pagination={{
                        "clickable": true
                    }}
                    autoplay={{
                        "delay": 2500,
                    }}
                    breakpoints={{
                        300:{
                            width: 360,
                            slidesPerView: 1
                        },
                        468:{
                            width: 480,
                            slidesPerView: 1
                        },
                        // when window width is >= 640px
                        640: {
                            width: 520,
                            slidesPerView: 1,
                        },
                        // when window width is >= 768px
                        768: {
                            width: 690,
                            slidesPerView: 1,
                        },
                        992: {
                            width: 1208,
                            slidesPerView: 2,
                        },
                        1199: {
                            width: 1408,
                            slidesPerView: 2,
                        },
                    }}
                    watchSlidesVisibility = {true}
                    autoHeight={true}
                    className="mySwiper">

                    <SwiperSlide className="swiper-slide">
                        <Row className="feedback-container text-white-1 align-items-center">
                            <Col xl={3} lg={3} md={3} className="align-self-start ">
                                <div className="">
                                    <img src={gamerI2} alt="" style={{ height: 100 }} />
                                </div>
                            </Col>
                            <Col xl={9}>
                                <CardTitle tag="h5">Player Name</CardTitle>
                                <Row className="justify-content-between">
                                    <Col sm={7}>
                                        <CardSubtitle className="mb-2 text-muted mt-2">San Francisco, mond...</CardSubtitle>
                                    </Col>
                                    <Col sm={5}>
                                        <CardSubtitle className="mb-2 text-muted mt-2">29 Augh 2021</CardSubtitle>
                                    </Col>
                                </Row>
                                <CardText className="text-grey-1">
                                    <p>
                                        “ Lorem ipsum dolor sit amet,
                                        consectetur adipiscing elit. Turpis posuere risus mi eget augue facilisis aenean ultrices.
                                        Orci sagittis sodales arcu “
                                    </p>
                                </CardText>
                            </Col>
                        </Row>
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        <Row className="feedback-container text-white-1 align-items-center">
                            <Col xl={3} lg={3} md={3} className="align-self-start ">
                                <div className="">
                                    <img src={gamerI1} alt="" style={{ height: 100 }} />
                                </div>
                            </Col>
                            <Col xl={9}>
                                <CardTitle tag="h5">Player Name</CardTitle>
                                <Row className="justify-content-between">
                                    <Col sm={7}>
                                        <CardSubtitle className="mb-2 text-muted mt-2">San Francisco, mond...</CardSubtitle>
                                    </Col>
                                    <Col sm={5}>
                                        <CardSubtitle className="mb-2 text-muted mt-2">29 Augh 2021</CardSubtitle>
                                    </Col>
                                </Row>
                                <CardText className="text-grey-1">
                                    <p>
                                        “ Lorem ipsum dolor sit amet,
                                        consectetur adipiscing elit. Turpis posuere risus mi eget augue facilisis aenean ultrices.
                                        Orci sagittis sodales arcu “
                                    </p>
                                </CardText>
                            </Col>
                        </Row>
                    </SwiperSlide>
                    <SwiperSlide className="swiper-slide">
                        
                    </SwiperSlide>
                </Swiper>
          */}
        <div className="d-none d-lg-block">
          {feedbacks && feedbacks.length ? (
            <>
              <Flickity
                options={{
                  freeScroll: false,
                  pageDots: true,
                  prevNextButtons: false,
                  wrapAround: true,
                  initialIndex: 0,
                }}
              >
                {feedbacks &&
                  feedbacks.map((feedback) => {
                    return (
                      <div className="carousel-cell">
                        <Container>
                          <Row className="feedback-container text-white-1 align-items-center">
                            <Col
                              xl={3}
                              lg={3}
                              md={3}
                              className="align-self-start "
                            >
                              <div className="">
                                <img
                                  src={feedback.image || gamerI2}
                                  alt=""
                                  style={{ width: "100%", height: "100%" }}
                                />
                              </div>
                            </Col>
                            <Col xl={9}>
                              <CardTitle tag="h5">
                                {feedback.player_name}
                              </CardTitle>
                              <Row className="justify-content-between">
                                <Col sm={7}>
                                  <CardSubtitle className="mb-2 text-muted mt-2">
                                    {feedback.location}
                                  </CardSubtitle>
                                </Col>
                                <Col sm={5}>
                                  <CardSubtitle className="mb-2 text-muted mt-2">
                                    {moment(feedback.date.toDate()).format("L")}
                                  </CardSubtitle>
                                </Col>
                              </Row>
                              <CardText className="text-grey-1">
                                <p>“ {feedback.feedback} “</p>
                              </CardText>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    );
                  })}
              </Flickity>
            </>
          ) : null}
        </div>
        <div className="d-block d-lg-none">
          <Swiper
            centeredSlides={true}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
            }}
          >
            {feedbacks &&
              feedbacks.map((feedback) => {
                return (
                  <SwiperSlide className="swiper-slide">
                    <Container>
                      <Row className="feedback-container text-white-1 align-items-center">
                        <Col xl={3} lg={3} md={3} className="align-self-start ">
                          <div className="">
                            <img
                              src={feedback.image || gamerI2}
                              alt=""
                              style={{ height: 100 }}
                            />
                          </div>
                        </Col>
                        <Col xl={9}>
                          <CardTitle tag="h5">{feedback.player_name}</CardTitle>
                          <Row className="justify-content-between">
                            <Col sm={7}>
                              <CardSubtitle className="mb-2 text-muted mt-2">
                                {feedback.location}
                              </CardSubtitle>
                            </Col>
                            <Col sm={5}>
                              <CardSubtitle className="mb-2 text-muted mt-2">
                                {moment(feedback.date).format("L")}
                              </CardSubtitle>
                            </Col>
                          </Row>
                          <CardText className="text-grey-1">
                            <p>“ {feedback.feedback} “</p>
                          </CardText>
                        </Col>
                      </Row>
                    </Container>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // auth: state.auth,
    content: state.content.content,
    feedbacks: state.feedback.feedbacks,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getFeedbacks: () => dispatch(getFeedbacks()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FeedbackCarousel);

{
  /* <Row className="justify-content-center">
                            <Col xl={7} lg={8} md={10} sm={12} xs={10}>
                                <Row className="mt-4 feedback-container text-white-1">
                                    <Col md={3} >
                                        <img src={gamerI2} alt="gamer1" style={{ height: "100px" }} />
                                    </Col>
                                    <Col lg={9} md={9}>
                                        <CardTitle tag="h5">Player Name</CardTitle>
                                        <Row className="justify-content-between">
                                            <Col sm={6}>
                                                <CardSubtitle className="mb-2 text-muted mt-2">San Francisco, mond...</CardSubtitle>
                                            </Col>
                                            <Col sm={4}>
                                                <CardSubtitle className="mb-2 text-muted mt-2">29 Augh 2021</CardSubtitle>
                                            </Col>
                                        </Row>
                                        <CardText className="text-grey-1">
                                            <p>
                                                “ Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit. Turpis posuere risus mi eget augue facilisis aenean ultrices.
                                                Orci sagittis sodales arcu “
                                    </p>
                                        </CardText>
                                    </Col>
                                </Row>
                            </Col>
                        </Row> */
}
